import { RefObject, useState, useEffect, useMemo } from 'react';
import { throttle } from 'underscore';

const useTrackSelectParentSize = ({ ref, pause }: { pause?: boolean; ref: RefObject<HTMLElement | null> }): DOMRect => {
  /* Tracks bounding rect of element, even on window resize, or when th element itself changes */
  const [rect, setRect] = useState<DOMRect>(new DOMRect(0, 0, 0, 0));

  useEffect(() => {
    if (!ref.current || pause) return;

    const updateRect = throttle(() => {
      if (ref.current) {
        setRect(ref.current.getBoundingClientRect());
      }
    }, 10);

    setRect(ref.current.getBoundingClientRect());

    const resizeObserver = new ResizeObserver(() => {
      updateRect();
    });

    resizeObserver.observe(ref.current);

    window.addEventListener('resize', updateRect);
    window.addEventListener('scroll', updateRect, true);

    return () => {
      resizeObserver.disconnect();
      window.removeEventListener('resize', updateRect);
      window.removeEventListener('scroll', updateRect, true);
    };
  }, [pause, ref]);

  return useMemo(() => rect, [rect]);
};

export default useTrackSelectParentSize;
